export {
  getStaticProps,
  OurCommitmentFeature as default,
} from '@cinch-nx/landing-feature-our-commitment'
